import { AnalysisStoreProvider } from '@modules/analysis/store/AnalysisStoreProvider';
import { SearchAnalysisToolbar } from '@modules/feed/components/SearchAnalysisToolbar';
import { SearchQueryBuilderV2 } from '@modules/feed/components/SearchQueryBuilder/SearchQueryBuilderV2';
import { QueryBuilderStoreProvider } from '@modules/queryBuilder/store/QueryBuilderStoreProvider';
import { Stack } from '@mui/material';
import { SearchAnalysesResults } from '../SearchAnalysesResults';

export function SearchAnalyses() {
  return (
    <Stack direction="column" spacing={3} sx={{ px: 3, pt: 2 }}>
      <SearchAnalysisToolbar />
      <AnalysisStoreProvider>
        <QueryBuilderStoreProvider>
          <SearchQueryBuilderV2 />
          <SearchAnalysesResults />
        </QueryBuilderStoreProvider>
      </AnalysisStoreProvider>
    </Stack>
  );
}
